import { HttpStatus, ResponseCode } from '@marketplace-web/core-api/api-client-util'

const NETWORK_RESPONSE_CODES = ['ETIMEDOUT', 'ERR_NETWORK', 'ERR_CANCELED']

const isSystemCode = (code: string) => NETWORK_RESPONSE_CODES.includes(code)

const isSystemStatus = (status: HttpStatus) => status >= 500

type Response = {
  status: HttpStatus | null
  code: string | ResponseCode
}

const isSystemErrorResponse = (response: Response) =>
  response.status ? isSystemStatus(response.status) : isSystemCode(response.code as string)

export default isSystemErrorResponse
